<template>
  <div class="">
    <div
        @click.prevent="onClick()"
        class="d-flex jc-between cur-pointer"
    >
      <div class="h3 text-bold c-gray90 p-l-6">{{title}}</div>
      <span class="PRE-LINE"/>
      <div class="ARROW">
        <vk-icon v-if="isOpen" name="chevrondown"/>
        <vk-icon v-else name="chevronup"/>
      </div>
    </div>
    <div :class="[isVisible ? 'SUB-SECTION' : 'CLOSED-SUB-SECTION']">
      <div
          v-if="isOpen"
          class="d-flex fd-column fw-wrap"
      >
        <div
            v-for="(item, index) in resources"
            :key="index">
          <resource-item
              :item="item"
              :index="index"
              :images="resources"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ResourceItem from './ResourceItem';

export default {
  name: 'resource-list',
  components: {
    ResourceItem,
  },
  props: {
    resources: {
      type: Array,
      default () { return []; },
    },
    title: {
      type: String,
      required: true,
    },

  },
  data () {
    return {
      isLoading: false,
      isOpen: false,
      isVisible: false,
    };
  },
  methods: {
    onClick () {
      if (this.isOpen) {
        this.isVisible = false;
        setTimeout(() => {
          this.isOpen = false;
        }, 400);
      } else {
        this.isOpen = true;
        setTimeout(() => {
          this.isVisible = true;
        }, 300);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.SECTION {
  max-width: $unit * 118;
}
.PRE-LINE {
  white-space: pre-line;
}
.TEXT-AREA{
  font-size: 18px;
  @include tablet{
    width: $unit * 88;
  }
}
.TEXT-ERROR{
  font-size: 18px;
  @include tablet{
    width: $unit * 90;
  }
}
.BUTTON{
  width: $unit * 27.5;
}
.IMAGE {
    max-width: 270px;
    padding-right: 2 * $unit;
    align-self: auto;
   &:last-child {
     padding-right: 0px;
    }
    @include mobile-only (){
      max-width: 98px;
    }
    @include tablet-only (){
      max-width: 150px;
    }
  }
.ARROW {
  margin: 10px 12px 5px 0px;
  color: $color-depot;
}
.SUB-SECTION {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}
.CLOSED-SUB-SECTION {
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}

</style>
